import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { RoundResultSimplified } from 'src/app/common/types/round-results-simplified.interface';
import { SeasonResult } from 'src/app/common/types/season-results.interface';
import { ColumnDef } from '../../competition-management/edit-competition-card/round-results-table/models/column-def.interface';
import { SeasonSpeedTrialResultsTableService } from './service/season-stage-results-table.service';

@Component({
  selector: 'app-season-speed-trial-results-table',
  templateUrl: './season-speed-trial-results-table.component.html',
  styleUrls: ['./season-speed-trial-results-table.component.css'],
  providers: [SeasonSpeedTrialResultsTableService],
})
export class SeasonSpeedTrialResultsTableComponent implements OnInit {
  displayedColumns: string[] = [];
  dataSource: MatTableDataSource<SeasonResult>;

  seasonId: number | null = null;
  competitionType: string | null = null;
  columns: ColumnDef[] = [];

  seasonResults: SeasonResult[] = [];

  constructor(
    private seasonResultsTableService: SeasonSpeedTrialResultsTableService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.seasonId = this.route.snapshot.params.competitionId as number;
    this.competitionType = this.route.snapshot.params.type as string;

    this.seasonResultsTableService
      .getSeasonSpeedTrialResultsBySeasonType(this.competitionType)
      .subscribe((seasonResults: SeasonResult[]) => {
        this.seasonResults = seasonResults;
        if (this.seasonResults.length > 0) {
          this.columns.push({
            header: 'Place',
            columnDef: 'place',
            type: 'field',
          });
          this.columns.push({
            header: 'Crew Number',
            columnDef: 'crewNumber',
            type: 'field',
          });
          for (let roundResult of seasonResults[0].roundResults) {
            let indexOfRound =
              seasonResults[0].roundResults.indexOf(roundResult);
            this.columns.push({
              header: 'Round ' + (indexOfRound + 1),
              columnDef: indexOfRound.toString(),
              type: 'array',
            });
          }
          this.columns.push({
            header: 'Championship Points',
            columnDef: 'totalNumberOfChampionshipPoints',
            type: 'field',
          });
          this.displayedColumns = this.displayedColumns.concat(
            this.columns.map((x) => x.columnDef.toString())
          );
          this.dataSource = new MatTableDataSource(
            seasonResults.sort(
              (a, b) =>
                b.totalNumberOfChampionshipPoints -
                a.totalNumberOfChampionshipPoints
            )
          );
          this.cdr.detectChanges();
        }
      });
  }

  crossRound(roundResults: RoundResultSimplified[], count: number): boolean {
    if (
      roundResults[count].symbol === 'MAX' ||
      roundResults[count].symbol === 'MIN'
    ) {
      return true;
    }
  }
}
